import React from 'react'
import '../css/Navbar.css'

const Navbar = () => {
    return (
        <nav className="navbar">
            <div className="container-fluid d-flex justify-content-between">
                <div className="navbar-brand">Sajjat Hossain</div>
                <div className="navbar-group">
                    <nav className="nav h3">
                        <a className="nav-link" href="#home">Home</a>
                        <a className="nav-link" href="#skills">Skills</a>
                        <a className="nav-link" href="#projects">Projects</a>
                        <a className="nav-link" href="#services">Services</a>
                        <a className="nav-link" href="#qualifications">Qualifications</a>
                        <a className="nav-link" href="#contact">Contact</a>
                    </nav>
                </div>
            </div>            
        </nav>
    )
}

export default Navbar
